const bezierControlPointMultiplier = (4 / 3) * Math.tan(Math.PI / 8)

export function drawRect(ctx, width, height, radiuses = [0, 0, 0, 0], offsetX = 0, offsetY = 0) {
  const xTL = offsetX
  const yTL = offsetY
  const xTR = offsetX + width
  const yTR = offsetY
  const xBR = offsetX + width
  const yBR = offsetY + height
  const xBL = offsetX
  const yBL = offsetY + height

  const [rTL, rTR, rBR, rBL] = radiuses
  // Start from TopLeft
  ctx.moveTo(xTL + rTL, yTL)
  // TopRight
  ctx.lineTo(xTR - rTR, yTR)
  if (rTR) {
    const controlPointOffset = rTR * bezierControlPointMultiplier
    ctx.bezierCurveTo(
      xTR - rTR + controlPointOffset,
      yTR,
      xTR,
      yTR + rTR - controlPointOffset,
      xTR,
      yTR + rTR,
    )
  }
  // BottomRight
  ctx.lineTo(xBR, yBR - rBR)
  if (rBR) {
    const controlPointOffset = rBR * bezierControlPointMultiplier
    ctx.bezierCurveTo(
      xTR,
      yBR - rBR + controlPointOffset,
      xBR - rBR + controlPointOffset,
      yBR,
      xBR - rBR,
      yBR,
    )
  }
  // BottomLeft
  ctx.lineTo(xBL + rBL, yBL)
  if (rBL) {
    const controlPointOffset = rBL * bezierControlPointMultiplier
    ctx.bezierCurveTo(
      xBL + rBL - controlPointOffset,
      yBL,
      xBL,
      yBL - rBL + controlPointOffset,
      xBL,
      yBL - rBL,
    )
  }
  // TopLeft
  ctx.lineTo(xTL, yTL + rTL)
  if (rTL) {
    const controlPointOffset = rTL * bezierControlPointMultiplier
    ctx.bezierCurveTo(
      xTL,
      yTL + rTL - controlPointOffset,
      xTL + rTL - controlPointOffset,
      yTL,
      xTL + rTL,
      yTL,
    )
  }
}
